<template>
<v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="time" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
  <template v-slot:activator="{ on }">
    <v-text-field box v-model="time" :label="$t('schedule.time')" :rules="rules" readonly v-on="on"></v-text-field>
  </template>
  <v-time-picker v-if="menu" v-model="time" format="24hr" :allowed-minutes="allowedStep" scrollable full-width @click:minute="$refs.menu.save(time)"></v-time-picker>
</v-menu>
</template>

<script>
export default {
  name: 'TimeSelector',
  props: {
    value: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      allowedStep: m => m % 5 === 0
    }
  },
  computed: {
    time: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    rules() {
      if (this.required) {
        return [
          v => !!v || this.$t('schedule.time_required')
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schedule/TimeSelector.vue